import DeviceMaintenance from 'features/integrations/features/device-maintenance/DeviceMaintenance.index';

export default function DeviceMaintenanceRoute() {
  return <DeviceMaintenance />;
}
